<template>
  <div id="data-list-list-view">
    <div class="line">
      <div class="lf">
         <v-select
          class="select-item"
          :options="options"
          :reduce="(opt) => opt.code"
          v-model="searchType"
        />
        <flat-pickr
          v-model="rangeDate"
          :config="flatPickerConfig"
          placeholder="选择时间"
          class="time-item-lf"/>
        <!-- 至
        <flat-pickr
          v-model="searchData.endDate"
          placeholder="选择结束时间"
          class="time-item-rt"/> -->

        <!-- <vs-input
          class="input-item"
          placeholder="请输入门店名称/门店编码"
          v-model="searchData.queryField"/> -->
        <search-input
          ref="storeSuggest"
          :autoFocus="true"
          :data="storeOptions"
          :searchLimit="5"
          placeholder="请输入门店名称/门店编码"
          inputClassses="w-full"
          show-action
          show-pinned
          hideGroupTitle
          background-overlay
          showName="name"
          remainInputValue
          @input="searchInputSuggest"
          @selected="selectOneStore" />
        <vs-button type="filled" size="small" @click="handleSearch" class="marLeft16 btn">查询</vs-button>

        <!-- <vs-button
          size="small"
          type="flat"
          icon-pack="feather"
          icon="icon-search"
          class="btn"
          radius
          @click="handleSearch">
        </vs-button> -->
      </div>
       <div class="rt">
         <!-- <a :href="exportUrl" download="门店售卖列表.xlsx"> -->
          <vs-button
                  v-if="filtering('storeSale:export')"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-home"
            class="export"
            @click="handleExport">
              导出
          </vs-button>
         <!-- </a> -->
      </div>
    </div>
    <vs-table :data="tableData" noDataText="暂无数据">
      <template slot="thead">
        <vs-th v-for="(headData, index) in headData" :key="index">
          {{ headData }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td style="width: 45px">{{ indextr + 1 }}</vs-td>
          <vs-td :data="tr.snCode" v-if="searchType === 1">
            {{ tr.snCode }}
          </vs-td>
          <vs-td :data="tr.venderCode" v-else>
            {{ tr.venderCode }}
          </vs-td>
          <vs-td :data="tr.skuName">
            {{ tr.skuName }}
          </vs-td>
          <vs-td :data="tr.categoryName">
            {{ tr.categoryName }}
          </vs-td>
          <vs-td :data="tr.storeCode">
            {{ tr.storeCode }}
          </vs-td>
          <vs-td :data="tr.storeName">
            {{ tr.storeName }}
          </vs-td>
          <vs-td :data="tr.date">
            {{ tr.date }}
          </vs-td>
          <template  v-if="searchType === 1">
            <vs-td :data="tr.remark" style="width: 180px">
              {{ tr.remark }}
            </vs-td>
            <vs-td :data="tr.status">
              {{ tr.status===1 ? '核销成功': '核销失败' }}
            </vs-td>
          </template>
          <vs-td :data="tr.part"  v-if="searchType === 2">
            {{tr.part}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- <gc-vs-pagination
      v-if="tableData.length"
      :total="Math.ceil(pagination.totalCount/pagination.pageSize)"
      v-model="pagination.page"
      :max-items="pagination.pageSize">
    </gc-vs-pagination>         -->
    <gc-vs-pagination
      v-if="tableData.length"
      :pager="pagination"
      totalName="totalCount"
      pageSizeName="pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></gc-vs-pagination>
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
  // import { Http } from "@/h5_src/network/http";
  import {storeSaleApi} from '@/modules/server-api/commodity-sys/distribution.ts'
  import {Local_Storage} from "@/store/local.storage";
  import SearchInput from '@/modules/wms-manage/components/searchInput.vue';

  export default {
    components: {
      flatPickr,SearchInput
    },
    data() {
      return {
        headData: [
          "序号",
          "SN码",
          "商品名称",
          "分类",
          "门店编码",
          "门店名称",
          "时间",
          "备注",
          "售卖状态"
        ],
        storeOptions: [], //门店选项
        searchData: {
          startDate: '',
          endDate: '',
          queryField: ''
        },
        searchType: 1,
        options: [
          { label: "按SN码查询", code: 1, text: 'SN码' },
          { label: "按厂家编码查询", code: 2, text: '厂家编码' }
        ],
        tableData: [],
        pagination: {
          totalCount: 0,
          page:1,
          pageSize: 20
        },
        rangeDate: '',
        flatPickerConfig: {
          locale: Mandarin, //日期控件中文
          mode: 'range',

        }
      }
    },
    created () {
      this.getNowDate();
      this.getList();
    },
    watch: {
      searchType: {
        handler(newValue, oldValue) {
          console.log(newValue)
          if(!newValue) {
            this.searchType = 1
          }
          if(newValue === 2) {
            this.headData = [
              "序号",
              "厂家编码",
              "商品名称",
              "分类",
              "门店编码",
              "门店名称",
              "时间",
              "售卖数量"
            ]
          } else {
            this.headData = [
              "序号",
              "SN码",
              "商品名称",
              "分类",
              "门店编码",
              "门店名称",
              "时间",
              "备注",
              "售卖状态"
            ]
          }
          this.handleSearch()
        },
      },
      // pagination: {
      //   handler(val) {
      //     this.getList()
      //   },
      //   deep:true
      // },
      rangeDate: {
        handler(val) {
          let temp
          if(val.indexOf('至')!== -1) {
            temp = val.split(' 至 ')
          } else {
            temp = [val,val]
          }
          console.log('val',val, temp)
          this.searchData.startDate = temp[0]
          this.searchData.endDate = temp[1]
          this.getList()
        },
      }
    },
    computed: {
      exportUrl() {
        return `/data-dist/api/dist//scanPay/exportSaleDetailExcel?type=${this.searchType}&startDate=${this.searchData.startDate}&endDate=${this.searchData.endDate}&queryField=${this.searchData.queryField}&pageNo=${this.pagination.page}&pageSize=${this.pagination.pageSize}`
      }
    },
    methods: {
      getNowDate() {
        let that = this;
        let myDate = new Date();
        let year, month, day;
        year = myDate.getFullYear();
        month = Number(myDate.getMonth()) + 1;
        day = myDate.getDate();
        that.rangeDate = year + '-' + month + '-' + day;
      },
      async getList() {
        this.$vs.loading();
        const res = await storeSaleApi.getList({
          ...this.searchData,
          type: this.searchType,
          pageNo: this.pagination.page,
          pageSize: this.pagination.pageSize,
        })
        console.log(res)
        if(res.succ) {
          this.tableData = res.result
          this.pagination.totalCount = res.total
           this.$vs.loading.close();
        }
         this.$vs.loading.close();
      },
      //模糊搜索门店
      async searchInputSuggest(value){
        if(value != ''){
          this.storeOptions = [];
          let res =  await storeSaleApi.searchStore({"search":value});
          if(res.succ == 1 && res.result){
            let resList = res.result.list;
            if(resList && resList.length > 0){
              this.storeOptions = resList.map(item => {
                let obj = {};
                obj.id = item.id;
                obj.name = item.name;
                return obj;
              });
              this.$forceUpdate();
            }
          }
        }else{
          this.searchData.queryField = '';
        }
      },
      //选择某一个门店
      selectOneStore(item){
        this.searchData.queryField = item.id;
        this.handleSearch();
      },
      // 搜索
      handleSearch() {
        this.pagination.page = 1
        this.pagination.pageSize = 20
        this.getList()
      },
      // 导出 ---这个方法会走到reject里边，但是没有返回错误信息。后续继续跟进
      //        现象：fetch没有这个问题，应该是axios源码问题
      async handleExport() {
        let Authorization = ''
        let savedSession = Local_Storage.getSession();
        let token = savedSession.token || '';
        if (token) {
          Authorization =token
        }
        this.$vs.loading();
        fetch(
          `/data-dist/api/dist//scanPay/exportSaleDetailExcel?type=${this.searchType}&startDate=${this.searchData.startDate}&endDate=${this.searchData.endDate}&queryField=${this.searchData.queryField}&pageNo=${this.pagination.page}&pageSize=${this.pagination.pageSize}`,
          {
          method: 'get',
          responseType: 'arraybuffer',
          headers:{
            'Authorization':Authorization
          }

        }).then(res=> {
          if (res.ok) {
            return res.blob();
          }
        })
        .then(res => {
          console.log('res ===>',res)
          // var blob = new Blob(
          //   [res.body],
          //   {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}
          // ); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(res); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = '门店售卖列表.xlsx'; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
          this.$vs.loading.close();
        }, res => {
          console.log('reject',res)
        }).catch((error => {
          console.log(arguments)
        }))
      },
      //更改每页条数
      handleSizeChange(val){
        this.pagination.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val){
        this.pagination.page = val;
        this.getList();
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/modules/commodity-sys/commodity.scss";
  @mixin flex-mixin($direction, $align, $justify) {
    display: flex;
    flex-direction: $direction;
    align-items: $align;
    justify-content: $justify;
  }
  .line {
    @include flex-mixin(row, center, space-between);
    margin-bottom: 15px;
    padding-top: 40px;
    .lf {
      @include flex-mixin(row, center, flex-start);
      .select-item {
        margin-right:24px;
        width: 160px;;
      }
      .time-item-lf {
        width: 200px;
        margin-right:24px;
      }
      .input-item {
        width: 160px;
      }
      .btn {
        width: 120px;
        /deep/ .vs-icon {
          font-size: 1.2rem;
          color: #5E5873
        }
      }
    }
    .rt {
      .export {
        padding: 8px 24px !important;
      }
    }
  }
</style>
